import React, { useState } from "react";

interface Props {
  children: React.ReactNode;
}

const PlateGifRowContainer: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(true);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        margin: 0,
        padding: 0,
      }}
    >
      {/* Arrow container with FIXED height */}
      <div
        style={{
          height: "200px",
          display: "flex",
          alignItems: "flex-start",
          marginRight: "6px",
        }}
      >
        <div
          onClick={() => setOpen(!open)}
          onMouseEnter={(e) => e.currentTarget.style.color = "#cc0000"}
          onMouseLeave={(e) => e.currentTarget.style.color = "red"}
          style={{
            width: "20px",
            height: "20px",
            cursor: "pointer",
            userSelect: "none",
            color: "red",
            fontSize: "20px",
            lineHeight: "20px",
            transition: "color 0.2s ease",
          }}
        >
          {open ? "▼" : "▶"}
        </div>
      </div>

      {/* Collapsible drawer */}
      <div
        style={{
          overflow: "hidden",
          transition: "width 0.35s ease, opacity 0.35s ease",
          width: open ? "200px" : "0px",
          opacity: open ? 1 : 0,
        }}
      >
        {open && <div style={{ width: "360px" }}>{children}</div>}
      </div>
    </div>
  );
};

export default PlateGifRowContainer;
